export default "__VITE_ASSET__Ri7YwJ1N__"